export const SET_USER_INFO = 'setUserInfo';
export const COMMIT_SET_USER_INFO = 'login/setUserInfo';
// 设置用户的promise
export const SET_USER_INFO_PROMISE = 'setGetUserInfoPromise';
export const COMMIT_SET_USER_INFO_PROMISE = `login/${SET_USER_INFO_PROMISE}`;

export const CHANGE_LOGIN_MODAL = 'changeLoginModal';
export const COMMIT_CHANGE_LOGIN_MODAL = 'login/changeLoginModal';

export const CHANGE_REGISTER_MODAL = 'changeRegisterModal';
export const COMMIT_CHANGE_REGISTER_MODAL = 'login/changeRegisterModal';

export const CHANGE_FORGOT_PASSWORD_MODAL = 'changeForgotPasswordModal';
export const COMMIT_CHANGE_FORGOT_PASSWORD_MODAL = 'login/changeForgotPasswordModal';
